/* src/app/user-info/user-info.component.scss */
h4 {
  display: inline-block;
  padding-left: 1rem;
}
/*# sourceMappingURL=user-info.component.css.map */
